(function($) {
	$(document).ready(function(){

		$('#search').on('click', function(){
			$('.search-form-container').toggleClass('show');
		});

	});
})(jQuery); // Fully reference jQuery after this point.